import axios from 'axios'
import Modal from 'bootstrap/js/src/modal'
import Dropdown from 'bootstrap/js/src/dropdown'
import Inputmask from "inputmask";

export default class DocumentSign {
    constructor() {
        // checkboxy
        this.elementFormDocumentTerms = document.getElementById('form-document-terms')

        //podpisywanie dokumentu
        this.elementDocumentConsentModal = document.getElementById('document-consent-modal')
        this.elementDocumentConsentModalSubmitButton = document.getElementById('form-document-consent-modal-submit-button')
        //this.elementDocumentTermsModalSubmitButton = document.getElementById('form-document-terms-modal-submit-button')
        this.elementFormDcoumentConsent = document.getElementById('form-document-consent')
        this.elementInputSmsCode = document.getElementById('input-sms-code')
        this.elementDocumentConsentModalInputAlert = document.getElementById('document-consent-modal-input-alert')
        this.elementSectionConsents = document.getElementById('section-consents')
        this.consentModal = new Modal(this.elementDocumentConsentModal)

        //odmowa podpisania dokumentu
        this.elementBtnDocumentDecline = document.getElementById('btn-document-decline')
        this.elementDocumentDeclineModal = document.getElementById('document-decline-modal')
        this.elementFormDocumentDecline = document.getElementById('form-document-decline')
        this.elementInputDeclineMessage = document.getElementById('input-decline-message')
        this.declineModal = new Modal(this.elementDocumentDeclineModal)


    }
    sign() {
        //zgody
        this.elementFormDocumentTerms.addEventListener('submit',(e) => {
            e.preventDefault()
            if(this.isValidForm(this.elementFormDocumentTerms)) {
                this.signRequest()
                    .then((res) => {
                        if(res.data.hasOwnProperty('status')) {
                            this.consentModal.hide()
                            window.location.href = `/documents/signed/${DOCUMENT_ID}`
                            return
                        }
                        this.switchFormVisibility('sign')
                    })
                    .catch((error) => {
                       if(error.response.data.hasOwnProperty('error')) {
                           document.getElementById('document-consent-modal-section-errors').innerHTML = '<div class="alert alert-warning my-3 w-100">' + error.response.data.error + '</div>';
                       }
                    })
                    .finally(()=>{
                        document.getElementById('document-consent-modal-section-spinner').classList.add('d-none')
                    })

            }else {
                this.switchFormVisibility('terms')
            }
        })

        //podpisywanie
        Inputmask({"mask": "999-999"},{jitMasking: true}).mask(this.elementInputSmsCode);
        this.elementFormDcoumentConsent.addEventListener('submit', (e) => {
            e.preventDefault()
            if(this.isValidForm(this.elementFormDcoumentConsent)) {
                this.signRequestWithSms()
            }

        })
       // okno podpisywania
        this.elementDocumentConsentModal.addEventListener('show.bs.modal',  (event) => {
            // resetowanie akceptacji regulaminu
            document.getElementById('consent-1').checked = false
            document.getElementById('form-document-terms').classList.remove('was-validated')
            this.switchFormVisibility('terms')
            document.getElementById('document-consent-modal-footer').classList.remove('d-none')

        })

    }

    decline() {
        [].slice.call(document.querySelectorAll('.btn-decline')).map((el)=>{
            el.addEventListener('click',(e)=>{
                this.openDeclineModal()
            })
        })
    }

    openDeclineModal(){
        this.declineModal.show()
        this.elementDocumentDeclineModal.addEventListener('hidden.bs.modal', (event) => {
            this.elementFormDocumentDecline.reset()
            this.elementFormDocumentDecline.classList.remove('was-validated')
        })

        this.elementFormDocumentDecline.addEventListener('submit',  (event) => {
            event.preventDefault()
            if(this.isValidForm(this.elementFormDocumentDecline)) {
                this.declineRequest().then(()=> {
                    window.location.reload(true);
                }).catch((e) => {
                    if(e.response.data.hasOwnProperty('error')) {
                        document.getElementById('document-decline-modal-alert').innerHTML = '<div class="alert alert-danger my-3">'+ e.response.data.error +'</div>'
                        setTimeout(()=> {
                            document.getElementById('document-decline-modal-alert').innerHTML = ''
                        },5000)
                    }
                })
            }
            this.elementFormDocumentDecline.classList.add('was-validated')


        }, false)
    }
    signRequest() {
        return axios.post('/documents/sign',{
            documentId: DOCUMENT_ID,
            signer: SIGNER
        })
    }
    signRequestWithSms()
    {

        this.setBtnLoadingState(this.elementDocumentConsentModalSubmitButton, true)
        axios.post('/documents/sign',{
            documentId: DOCUMENT_ID,
            smsCode: Inputmask.unmask(this.elementInputSmsCode.value, { mask: "999-999" }),
            signer: SIGNER
        }).then(()=>{
            this.consentModal.hide()
            window.location.href = `/documents/signed/${DOCUMENT_ID}`
        }).catch(error => {
            this.elementDocumentConsentModalInputAlert.innerHTML = '<div class="alert alert-danger my-3">'+ error.response.data.error +'</div>'
            setTimeout(()=> {
                this.elementDocumentConsentModalInputAlert.innerHTML = ''
            },5000)
        }).finally(() => {
            this.setBtnLoadingState(this.elementDocumentConsentModalSubmitButton, false)
        })
    }
    declineRequest() {
        return axios.post('/documents/cancel',{
            documentId: DOCUMENT_ID,
            message: this.elementInputDeclineMessage.value,
            signer: SIGNER
        })
    }
    isValidForm(form) {
        form.classList.add('was-validated')
        return form.checkValidity()
    }
    setBtnLoadingState(element,state) {
        let spinner =  element.querySelector('.spinner-border')
        element.disabled = state
        state ? spinner.classList.remove('invisible') :  spinner.classList.add('invisible')
    }
    switchFormVisibility(section) {

        if(section === 'sign') {
            document.getElementById('document-consent-modal-section-sign').classList.remove('d-none')
            document.getElementById('form-document-consent-modal-submit-button').classList.remove('d-none')
            document.getElementById('document-consent-modal-section-terms').classList.add('d-none')
            document.getElementById('form-document-consent-modal-submit-terms-button').classList.add('d-none')
            document.getElementById('form-document-consent').classList.remove('was-validated')
        }
        if(section === 'terms'){
            document.getElementById('document-consent-modal-section-sign').classList.add('d-none')
            document.getElementById('form-document-consent-modal-submit-button').classList.add('d-none')
            document.getElementById('document-consent-modal-section-terms').classList.remove('d-none')
            document.getElementById('form-document-consent-modal-submit-terms-button').classList.remove('d-none')
        }
        if(section === 'spinner'){
          console.log('spinner')  }
    }
}
